var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SingleLayout',{attrs:{"item":true}},[_c('template',{slot:"item"},[(_vm.playlist)?_c('PlaylistEditor',{attrs:{"playlist":_vm.playlist}}):_vm._e()],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }